import type { ReactElement } from 'react';
import { NavLink } from 'react-router';

/**
 * 1차 오픈 범위(14 §8) — 내 클래스·구매내역·배송조회·프로필을 뺐다.
 * 살 것이 없으니 내역도 없다. 2차 오픈은 여기 배열을 되돌리면 된다.
 *
 * `end` 를 붙인 항목은 **정확히 그 경로일 때만** 켜진다. `/my` 는 `/my/account` 의
 * 접두사라 이게 없으면 하위 화면에서 탭 두 개가 동시에 켜진다.
 */
const TABS = [
  { to: '/my', label: '마이페이지', end: true },
  { to: '/my/downloads', label: '받은 자료', end: false },
  { to: '/my/account', label: '계정', end: false },
] as const;

const ITEM = 'block rounded-md px-3 py-2 text-[14px] transition-colors';

/**
 * 마이페이지 사이드 메뉴.
 *
 * 넓은 화면에서는 왼쪽에 세로로 세운다 — 항목이 늘어나도 본문을 밀어내지 않고,
 * 지금 어디에 있는지가 스크롤과 무관하게 계속 보인다.
 * 좁은 화면에서는 가로로 흘린다. 세로로 쌓으면 본문이 화면 아래로 밀려난다.
 */
export function MyNav({ hasPhysicalOrder = false }: { hasPhysicalOrder?: boolean }): ReactElement {
  const tabs = TABS.filter((tab) => !('physicalOnly' in tab) || hasPhysicalOrder);

  return (
    <nav aria-label="마이페이지 메뉴">
      <ul className="flex gap-1 overflow-x-auto lg:flex-col [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {tabs.map((tab) => (
          <li key={tab.to} className="shrink-0 lg:shrink">
            <NavLink
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `${ITEM} ${
                  isActive
                    ? 'bg-secondary font-medium text-foreground'
                    : 'text-muted-foreground hover:bg-secondary/60 hover:text-foreground'
                }`
              }
            >
              {tab.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
